export default function pageHiding(GTM_OPTIMIZE_ID, timeout = 4000) {
    // Refers to https://developers.google.com/optimize/devguides/pagehiding
    // eslint-disable-next-line
    (function(a, s, y, n, c, h, i, d, e) {
        s.className = `${s.className} ${y}`;
        h.start = 1 * new Date();
        h.end = i = function() {
            s.className = s.className.replace(RegExp(` ?${y}`), '');
        };
        (a[n] = a[n] || []).hide = h;
        setTimeout(() => {
            i();
            h.end = null;
        }, c);
        h.timeout = c;
    })(window, document.documentElement, 'async-hide', 'dataLayer', timeout, { [GTM_OPTIMIZE_ID]: true });
}
